/* tslint:disable */
/* eslint-disable */
/**
 * Default API
 * All endpoints not defined under specific APIs
 *
 * The version of the OpenAPI document: Latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  VoteStatus,
  VoteStatusFromJSON,
  VoteStatusFromJSONTyped,
  VoteStatusToJSON,
} from "./";

/**
 *
 * @export
 * @interface VoteOutput
 */
export interface VoteOutput {
  /**
   *
   * @type {VoteStatus}
   * @memberof VoteOutput
   */
  status: VoteStatus;
}

export function VoteOutputFromJSON(json: any): VoteOutput {
  return VoteOutputFromJSONTyped(json, false);
}

export function VoteOutputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): VoteOutput {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    status: VoteStatusFromJSON(json["status"]),
  };
}

export function VoteOutputToJSON(value?: VoteOutput | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    status: VoteStatusToJSON(value.status),
  };
}
